import {
    Badge,
    Breadcrumb,
    Button,
    Card,
    Checkbox,
    Col,
    Empty,
    Grid,
    Popover,
    Progress,
    Row,
    Space,
    Spin,
    Typography,
    message,
    theme,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { api, api_url } from "../../services/api";
import { getProfileLocal, setCoursesLocal, setProfileLocal } from "../../utils/common";

import AppLayout from "../../components/Layout";
import Container from "../../components/util-components/Container";
import { FilterOutlined } from "@ant-design/icons";
import { courseDataState } from "../../components/Atoms/Course/courseData";
import { useRecoilState } from "recoil";

const { useToken } = theme;
const { useBreakpoint } = Grid;


const CardLibCourse = ({ course, getCourses, ...props }) => {

    const { token } = useToken();
    const screens = useBreakpoint();

    const navigate = useNavigate();


    const [loading, setLoading] = useState(false);



    return (
        <Col
            span={24}
            sm={24}
            md={24}
            lg={8}
            xl={6}
            style={{
                padding: !screens?.md ? '0 20px' : '10px',
                width: "100%",
                margin: !screens?.md ? '0 auto' : '',
            }}
        >
            <Card
                className="card"
                {...props}
                cover={
                    <div
                        className="cover"
                        style={{
                            width: "100%",
                            backgroundColor: "#F5DB33",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                        }}
                    >

                        <img
                            alt={'Imagem do curso'}
                            src={`${api_url}/upload/${course.thumbnail_path}`}
                            style={{
                                width: "100%",
                                objectFit: "cover",
                            }}

                        />
                    </div>
                }
            >

                <div className="flex">
                    <div className="card-body">
                        <span style={{ padding: "10px" }}>{course?.name || "Nome do curso"}</span>

                        <div className="flex-button">
                            {!course?.is_enrolled ? (
                                <Button
                                    loading={loading}
                                    type="link"
                                    className="continue-button"
                                    style={{
                                        backgroundColor: token.colorPrimaryHover,
                                        width: '100%',
                                    }}
                                    onClick={async () => {
                                        setLoading(true)
                                        try {

                                            const { data: res } = await api.post(`/panel/library/${course?.hash}`)

                                            res?.message ? message.success(res.message) : message.success('Matriculado com sucesso')

                                            getCourses()


                                        } catch (error) {
                                            console.log(error)
                                            message.error('Erro ao se matricular no curso')
                                        } finally {
                                            setLoading(false)
                                        }
                                    }}
                                >
                                    Inscrever
                                </Button>
                            ) : (
                                <Button
                                    type="primary"
                                    className="continue-button"
                                    style={{
                                        width: '100%',
                                    }}
                                    disabled
                                >
                                    Matrículado
                                </Button>
                            )}
                        </div>
                    </div>
                </div >
            </Card >

        </Col >
    )
}

const CourseLibrary = () => {

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);

    const [filter, setFilter] = useState('all');
    const [empty, setEmpty] = useState(false);


    const getCourses = async () => {
        setLoading(true)
        try {
            const { data: res } = await api.get(`/panel/library`)

            setCoursesLocal(res.data);
            setCourses(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }

    };

    useEffect(() => {
        getCourses();
    }, []);



    useEffect(() => {
        setEmpty(false)
    }, [filter])


    const [maxHeight, setMaxHeight] = useState(0);
    const cardRefs = useRef([]);

    useEffect(() => {
        // Encontra a altura máxima dos cards
        let height = 0;
        cardRefs.current.forEach((ref) => {
            if (ref.clientHeight > height) {
                height = ref.clientHeight;
            }
        });
        setMaxHeight(height);
    }, [courses]);

    return (
        <Container>
            <Spin
                spinning={loading}
            >

                <>
                    <Row
                        justify="space-between"
                        align="top"
                        style={{ marginBottom: "14px" }}
                    >
                        <Typography className="title-header">
                            Biblioteca de Cursos
                        </Typography>
                        {/* <Space>

                            <Button
                                {...filter === 1 && { type: 'primary' }}
                                onClick={() => setFilter(1)}
                            >Cursos Regulares</Button>
                            <Button
                                {...filter === 0 && { type: 'primary' }}
                                onClick={() => setFilter(0)}
                            >Awesomeness Academy</Button>
                            <Button
                                {...filter === 'all' && { type: 'primary' }}
                                onClick={() => setFilter('all')}
                            >Todos</Button>
                        </Space> */}
                    </Row>



                    <Row style={{ marginBottom: "41px" }}>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Link to="/" className="breadcrumb-link">
                                    Panel
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Biblioteca de Cursos</Breadcrumb.Item>
                        </Breadcrumb>
                    </Row>

                    {(courses.length === 0 || empty) && (
                        <Empty
                            description={
                                <span
                                    style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: '#646363'
                                    }}
                                >
                                    Nenhum curso encontrado
                                </span>
                            }
                            style={{
                                marginTop: '20px'
                            }}

                        />
                    )}

                    {(courses && !empty) && (
                        <>
                            {courses?.map((category, i) => (
                                <div key={i} style={{marginTop: 20}}>
                                    <Typography className="title-header">
                                        {category?.name ?? 'Categoria'}
                                    </Typography>
                                    <Row
                                        gutter={[10, 10]}
                                        style={{
                                            marginBottom: "41px",
                                            maxHeight: "600px",
                                            overflowY: "auto",

                                        }}
                                    >
                                        {category?.courses?.length > 0 ? category?.courses?.map(course => (
                                            <CardLibCourse 
                                             key={i}
                                              course={course}
                                              getCourses={getCourses} 
                                             />
                                        )) : setEmpty(true)}
                                    </Row>
                                </div>

                            ))}
                        </>
                    )}
                </>

            </Spin>
        </Container>
    );
};

export default CourseLibrary;
